<script>
  import dayjs from 'dayjs'
  import Card from '../../components/card.svelte'
  import StatCell from './stat_cell.svelte'

  let { pulse } = $props()

  const zone = $derived(pulse.time_zone === 'America/New_York' ? 'ET' : pulse.time_zone)

  const quests = $derived(
    pulse.quests && [
      { label: 'Submissions', value: pulse.quests.submissions },
      { label: 'Approved', value: pulse.quests.approved },
      { label: 'Rejected', value: pulse.quests.rejected },
      { label: 'Failed uploads', value: pulse.quests.failed_uploads }
    ]
  )

  const social = $derived(
    pulse.social && [
      { label: 'Moments', value: pulse.social.moments_posted },
      { label: 'Hypes', value: pulse.social.hypes },
      { label: 'Friend requests', value: pulse.social.friend_requests },
      { label: 'Signups', value: pulse.social.new_signups, title: 'Users created today in social-enabled areas' },
      { label: 'Moment reports', value: pulse.social.moment_reports },
      { label: 'User reports', value: pulse.social.user_reports },
      {
        label: 'Auto-hidden',
        value: pulse.social.auto_hidden_moments,
        title: 'Moments currently hidden by reports that received a report today'
      }
    ]
  )
</script>

{#snippet group(label, tiles)}
  <h3 class="text-xs font-semibold uppercase tracking-wide text-base-content/60 mb-2">{label}</h3>
  <div class="grid grid-cols-2 gap-2 mb-4 last:mb-0">
    {#each tiles as tile (tile.label)}
      <StatCell value={tile.value} label={tile.label} title={tile.title} />
    {/each}
  </div>
{/snippet}

<Card title="Today">
  {#snippet actions()}
    <span class="text-sm text-base-content/60">{dayjs(pulse.date).format('ddd, MMM D')} · Zupp day, {zone}</span>
  {/snippet}
  {#if quests}{@render group('Quests', quests)}{/if}
  {#if social}{@render group('Social', social)}{/if}
</Card>
